import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { IPlacesAutocompleteOutput } from '@app/shared/components/places-autocomplete/places-autocomplete-action-output.interface';
import { PlacesAutocompleteActionEnum } from '@app/shared/components/places-autocomplete/places-autocomplete-action.enum';
import { IDepartment, IPlacesAutocompleteResult } from '@app/shared/models';
import { DepartmentService } from '@app/shared/services/department/department.service';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit, OnDestroy {

  selectedDepartment: IDepartment;
  selectedPlace: string;

  departments: IDepartment[];
  places: IPlacesAutocompleteResult[];

  private masterSubscription = new Subscription();

  constructor(
    private seoService: SEOService,
    private departmentService: DepartmentService,
    private router: Router) {

    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'HOMEPAGE.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'HOMEPAGE.META-DESCRIPTION'
      }
    ]);
  }

  ngOnInit(): void {
    const sub = this.departmentService.getDepartments()
      .subscribe((departments: IDepartment[]) => {
        this.departments = departments;
      });
    this.masterSubscription.add(sub);
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  onPlaceSelected(placeOutput: IPlacesAutocompleteOutput) {
    switch (placeOutput.actionPerformed) {
      case PlacesAutocompleteActionEnum.InputBlurred:
        this.selectedPlace = placeOutput.selectedPlace;
        break;
      default:
        this.selectedPlace = placeOutput.selectedPlace;
        this.searchSalons();
    }
  }

  searchSalons(): void {
    if (!this.selectedPlace) {
      return;
    }
    if (!this.selectedDepartment) {
      this.router.navigate(['/salons', this.selectedPlace]);
      return;
    }
    this.router.navigate(['/salons', this.selectedPlace, this.selectedDepartment.name]);
  }
}
